.defaultPaperCss {
	/* background-color: aquamarine !important; */
	padding: 50px;
	max-width: 450px;
	margin-top: 16px !important;
	margin-bottom: 16px !important;
	margin-left: auto;
	margin-right: auto;
}
